import React, { useState, useEffect } from 'react';
import apiClient from '../api/apiClient';
import './EditCensorModal.css'; // Genbrug styles

const CreateUserModal = ({ onClose, onCreate }) => {
  // Data til dropdowns
  const [candidates, setCandidates] = useState({ censorer: [], kontaktpersoner: [] });
  const [loading, setLoading] = useState(true);

  // Form State
  const [formData, setFormData] = useState({
    email: '',
    firstName: '',
    lastName: '',
    role: 'TEACHER', // Default
    censorId: '',
    kontaktId: '',
    linkType: 'none' // 'none', 'censor', 'kontakt'
  });

  // Hent kandidater ved start
  useEffect(() => {
    const loadCandidates = async () => {
      try {
        const res = await apiClient.get('/api/users/candidates');
        setCandidates(res.data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false); // Kører ALTID, så den ikke hænger
      }
    };
    loadCandidates();
  }, []);

  // Håndter valg af person i dropdown
  const handleLinkChange = (e) => {
    const value = e.target.value; // Format: "type-id" (fx "censor-5")

    if (value === 'none') {
      setFormData(prev => ({ ...prev, linkType: 'none', censorId: '', kontaktId: '', email: '', firstName: '', lastName: '' }));
      return;
    }

    const [type, idStr] = value.split('-');
    const id = parseInt(idStr);

    // Find personen i listerne for at auto-udfylde navne
    let person = null;
    let newRole = formData.role;

    if (type === 'censor') {
      person = candidates.censorer.find(c => c.id === id);
      newRole = 'TEACHER'; // Foreslå Teacher rolle
      setFormData(prev => ({
        ...prev,
        linkType: 'censor',
        censorId: id,
        kontaktId: '',
        role: newRole,
        // Auto-fill:
        email: person.email,
        firstName: person.fornavn,
        lastName: person.efternavn
      }));
    } else if (type === 'kontakt') {
      person = candidates.kontaktpersoner.find(k => k.id === id);
      newRole = 'SC_ADMIN'; // Foreslå SC_ADMIN rolle

      // Kontaktpersoner har ofte fulde navn i ét felt, vi splitter det groft
      const names = person.navn.split(' ');
      const lName = names.length > 1 ? names.pop() : '';
      const fName = names.join(' ');

      setFormData(prev => ({
        ...prev,
        linkType: 'kontakt',
        censorId: '',
        kontaktId: id,
        role: newRole,
        // Auto-fill:
        email: person.email,
        firstName: fName,
        lastName: lName
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onCreate(formData);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">Opret Bruger Login</h2>
          <button className="close-btn" onClick={onClose}>&times;</button>
        </div>

        {loading ? <p>Henter medarbejdere...</p> : (
          <form onSubmit={handleSubmit}>
            <div className="modal-form-grid">

              {/* VÆLG PERSON (Kandidat) */}
              <div className="form-group full-width" style={{ background: '#f8f9fa', padding: '15px', borderRadius: '8px', border: '1px solid #e9ecef' }}>
                <label>Vælg medarbejder (Knyt til eksisterende)</label>
                <select
                  onChange={handleLinkChange}
                  style={{ width: '100%', padding: '10px', border: '1px solid #003366' }}
                >
                  <option value="none">-- Opret uden tilknytning --</option>

                  <optgroup label="Censorer / Undervisere">
                    {candidates.censorer.map(c => (
                      <option key={`c-${c.id}`} value={`censor-${c.id}`}>
                        {c.fornavn} {c.efternavn} ({c.sc_navn}) - {c.email}
                      </option>
                    ))}
                  </optgroup>

                  <optgroup label="Kontaktpersoner / Ledelse">
                    {candidates.kontaktpersoner.map(k => (
                      <option key={`k-${k.id}`} value={`kontakt-${k.id}`}>
                        {k.navn} ({k.sc_navn}) - {k.rolle}
                      </option>
                    ))}
                  </optgroup>
                </select>
                <small style={{ color: '#666', display: 'block', marginTop: '5px' }}>
                  Vælger du en person, udfyldes felterne nedenfor automatisk.
                </small>
              </div>

              {/* FELTER */}
              <div className="form-group">
                <label>Fornavn</label>
                <input value={formData.firstName} onChange={e => setFormData({ ...formData, firstName: e.target.value })} required />
              </div>
              <div className="form-group">
                <label>Efternavn</label>
                <input value={formData.lastName} onChange={e => setFormData({ ...formData, lastName: e.target.value })} required />
              </div>
              <div className="form-group full-width">
                <label>Email (Brugernavn)</label>
                <input type="email" value={formData.email} onChange={e => setFormData({ ...formData, email: e.target.value })} required />
              </div>

              <div className="form-group full-width">
                <label>Rolle i systemet</label>
                <select value={formData.role} onChange={e => setFormData({ ...formData, role: e.target.value })} style={{ width: '100%', padding: '10px' }}>
                  <option value="TEACHER">Underviser / Censor (Adgang til egne hold)</option>
                  <option value="SC_ADMIN">Administrator (Fuld adgang til sprogcenter)</option>
                </select>
              </div>

            </div>

            <div className="modal-actions" style={{ marginTop: '20px' }}>
              <button type="button" className="btn-cancel" onClick={onClose}>Annuller</button>
              <button type="submit" className="btn-save">Opret Bruger</button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default CreateUserModal;